<section
  class="insight-grid"
  [attr.aria-label]="'dairyYieldScan.summary.insights.label' | translate"
>
  <article class="insight-card" aria-labelledby="compliments-heading">
    <header>
      <mat-icon class="badge-icon" aria-hidden="true">verified</mat-icon>
      <div>
        <p class="eyebrow">{{ 'dairyYieldScan.summary.insights.topThree' | translate }}</p>
        <h2 id="compliments-heading">
          {{ 'dairyYieldScan.summary.insights.compliments' | translate }}
        </h2>
      </div>
    </header>
    @if (compliments.length > 0) {
      <ol>
        @for (compliment of compliments; track compliment.questionKey) {
          <li>
            <div>
              <strong>{{ compliment.questionKey + '.title' | translate }}</strong>
              <small>{{ answerKey(compliment.questionKey, compliment.option) | translate }}</small>
            </div>
            @if (showComplimentOption) {
              <span>{{ answerOptionKey(compliment.option) | translate }}</span>
            }
          </li>
        }
      </ol>
    } @else {
      <p class="empty-insight" data-test="no-compliments">
        {{ 'dairyYieldScan.summary.insights.noCompliments' | translate }}
      </p>
    }
  </article>

  <article class="insight-card" aria-labelledby="improvements-heading">
    <header>
      <mat-icon class="trend-icon" aria-hidden="true">trending_up</mat-icon>
      <div>
        <p class="eyebrow">{{ 'dairyYieldScan.summary.insights.topThree' | translate }}</p>
        <h2 id="improvements-heading">
          {{ 'dairyYieldScan.summary.insights.improvements' | translate }}
        </h2>
      </div>
    </header>
    @if (improvements.length > 0) {
      <ol>
        @for (improvement of improvements; track improvement.questionKey) {
          <li>
            <div>
              <strong>{{ improvement.questionKey + '.actionpoint' | translate }}</strong>
              <small>{{
                answerKey(improvement.questionKey, improvement.option) | translate
              }}</small>
            </div>
            <span>+ {{ improvement.potential | number: '1.1-1' }} kg</span>
          </li>
        }
      </ol>
    } @else {
      <p class="empty-insight" data-test="no-improvements">
        {{ 'dairyYieldScan.summary.insights.noImprovements' | translate }}
      </p>
    }
  </article>
</section>
